import {
    LAUNCHER_UPDATE_READY_STATE,
} from '../constants'

const initialState = {
    isReady: false,
}

export default function launcher(state = initialState, action) {
    switch (action.type) {
        // Update the state of launcher readiness
        case LAUNCHER_UPDATE_READY_STATE:
            return { isReady: action.payload }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/launcher.js